module.exports = __webpack_public_path__ + "img/pijl-scroll-verder.80cb5cdfcdb0a890e39e72099264b123.svg";